export const loggedInLinks = [
    {
        id: 1,
        name: 'My Account',
        link: '/account',
        expanded: false,
        children: []
    },
    {
        id: 2,
        name: 'My Services',
        link: '/services',
        expanded: false,
        children: []
    }
];

export const loggedOutLinks = [
    {
        id: 4,
        name: 'Login',
        link: '/login',
        expanded: false,
        children: []
    },
    {
        id: 5,
        name: 'Register',
        link: '/register',
        expanded: false,
        children: []
    }
];

export const adminLinks = [
    {
        id: 6,
        name: 'Administration',
        link: null,
        expanded: false,
        children: [
            {
                id: 7,
                name: 'User Management',
                link: '/admin/users',
                expanded: false,
                children: []
            },
            {
                id: 8,
                name: 'Service Licences',
                link: '/admin/licences',
                expanded: false,
                children: []
            },
            {
                id: 9,
                name: 'Licence Management',
                link: '/admin/manage-licences',
                expanded: false,
                children: []
            }
        ]
    }
];